export const isNumber = (value: string): boolean => {
  return value.indexOf("*") < 0 && value.toLocaleLowerCase().indexOf("x") < 0;
};

export const getBlockSize = (number: string): number => {
  if (number.indexOf("x") < 0 && number.indexOf("*") < 0) {
    return 1;
  }

  const length = Math.max(number.split("x").length, number.split("*").length);
  return Math.pow(10, length - 1) + getBlockSize(number.replace(/(\*|x)/, ""));
};

export const isValidNumberLength = (
  prefix: string,
  number: string,
): true | string => {
  if (number.length < 3) {
    return "Die minimale Länge der Rufnummer beträgt 3 Ziffern.";
  }

  if (number.length > 10) {
    return "Die maximale Länge der Rufnummer beträgt 10 Ziffern.";
  }

  if (prefix.startsWith("0160")) {
    return number.length !== 7 && number.length !== 8
      ? "Rufnummern mit der Vorwahl 0160 müssen eine Länge von 7 oder 8 Ziffern haben."
      : true;
  }

  if (prefix.startsWith("0176")) {
    return number.length !== 8
      ? "Rufnummern mit der Vorwahl 0176 müssen eine Länge von 8 Ziffern haben."
      : true;
  }

  if (prefix.startsWith("01") && number.length !== 7) {
    return "Rufnummern für Mobilfunknummern müssen eine Länge von 7 Ziffern haben.";
  }

  return true;
};
